import { FC, useContext } from 'react'
import { Modal } from '../components/modal/Modal'
import { UploadFormDrop } from './UploadFormDrop'
import { AppContext } from '../AppContext'
import './UploadDrop.scss'
import { useSuppressCutterHotkeys } from '../hooks/useSuppressCutterHotkeys'

export const UploadDrop: FC = () => {
  const { setUploadOpened } = useContext(AppContext)

  useSuppressCutterHotkeys()

  return (
    <Modal className="UploadDrop" header="Drop audio file" close={() => setUploadOpened(false)}>
      <UploadFormDrop caption="Drop elsewhere" />
    </Modal>
  )
}
